import React from 'react';
import { HomeFeed } from './Home';

export const ProfileMyPostsMobileView = (props) => {
    return (
        <HomeFeed filterByUser={props.match.params.profileId} blockPosts={true} />
    );
}